// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AcceptCookie_wrapper__Vlvqj","inner":"AcceptCookie_inner__TXsog","title":"AcceptCookie_title__p16uE","btn":"AcceptCookie_btn__TwAti"};